<script setup lang="ts">
import Pdf from "@/components/Pdf.vue"
import { type Invitation } from "@/model/app/invitation"
import SignStaffAppGeneralTerms from "@/pages/Tasks/Tasks/Staff/SignStaffAppGeneralTerms.vue"
import { type TasksProps } from "@/pages/Tasks/Tasks/tasks-props"
import { useHttpClient } from "@/vf"

const props = defineProps<TasksProps<Invitation>>()

const emit = defineEmits<{
    (e: "updated"): void
}>()

const http = useHttpClient()

async function signed(form: FormData) {
    await http.post(`/invitation/${props.task.token}/accept-to-admin`, form)
    emit("updated")
}
</script>

<template>
    <div class="bg-white p-4">
        <div class="row">
            <div class="col-lg-6">
                <Pdf file="/legal/show/General.Staff/pdf"></Pdf>
            </div>

            <div class="col-lg-6">
                <div class="mt-3"></div>
                <template v-if="props.task.state == 'open'">
                    <SignStaffAppGeneralTerms @signed="signed"></SignStaffAppGeneralTerms>
                </template>
            </div>
        </div>
    </div>
</template>
